'use strict';

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var utils = require('../utils');

var pMap = require('p-map');

var _require = require('uint8arrays/equals'),
    uint8ArrayEquals = _require.equals;

var _require2 = require('uint8arrays/compare'),
    uint8ArrayCompare = _require2.compare;

var _require3 = require('uint8arrays/xor'),
    uint8ArrayXor = _require3.xor;
/**
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('../').PeerData} PeerData
 */

/**
 * Maintains a list of peerIds sorted by distance from a DHT key.
 */


var PeerDistanceList = /*#__PURE__*/function () {
  /**
   * Creates a new PeerDistanceList.
   *
   * @param {Uint8Array} originDhtKey - the DHT key from which distance is calculated
   * @param {number} capacity - the maximum size of the list
   */
  function PeerDistanceList(originDhtKey, capacity) {
    _classCallCheck(this, PeerDistanceList);

    this.originDhtKey = originDhtKey;
    this.capacity = capacity;
    /** @type {{ peerId: PeerId, distance: Uint8Array }[]} */

    this.peerDistances = [];
  }
  /**
   * The length of the list
   */


  _createClass(PeerDistanceList, [{
    key: "length",
    get: function get() {
      return this.peerDistances.length;
    }
    /**
     * The peerIds in the list, in order of distance from the origin key
     */

  }, {
    key: "peers",
    get: function get() {
      return this.peerDistances.map(function (pd) {
        return pd.peerId;
      });
    }
    /**
     * Add a peerId to the list.
     *
     * @param {PeerId} peerId
     */

  }, {
    key: "add",
    value: function () {
      var _add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peerId) {
        var dhtKey, el;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.peerDistances.find(function (pd) {
                  return uint8ArrayEquals(pd.peerId.id, peerId.id);
                })) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return utils.convertPeerId(peerId);

              case 4:
                dhtKey = _context.sent;
                el = {
                  peerId: peerId,
                  distance: uint8ArrayXor(this.originDhtKey, dhtKey)
                };
                this.peerDistances.push(el);
                this.peerDistances.sort(function (a, b) {
                  return uint8ArrayCompare(a.distance, b.distance);
                });
                this.peerDistances = this.peerDistances.slice(0, this.capacity);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function add(_x) {
        return _add.apply(this, arguments);
      }

      return add;
    }()
    /**
     * Indicates whether any of the peerIds passed as a parameter are closer
     * to the origin key than the furthest peerId in the PeerDistanceList.
     *
     * @param {PeerId[]} peerIds
     */

  }, {
    key: "anyCloser",
    value: function () {
      var _anyCloser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(peerIds) {
        var dhtKeys, furthestDistance, _iterator, _step, dhtKey, keyDistance;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (peerIds.length) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", false);

              case 2:
                if (this.length) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", true);

              case 4:
                _context2.next = 6;
                return pMap(peerIds, function (peerId) {
                  return utils.convertPeerId(peerId);
                });

              case 6:
                dhtKeys = _context2.sent;
                furthestDistance = this.peerDistances[this.peerDistances.length - 1].distance;
                _iterator = _createForOfIteratorHelper(dhtKeys);
                _context2.prev = 9;

                _iterator.s();

              case 11:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 18;
                  break;
                }

                dhtKey = _step.value;
                keyDistance = uint8ArrayXor(this.originDhtKey, dhtKey);

                if (!(uint8ArrayCompare(keyDistance, furthestDistance) < 0)) {
                  _context2.next = 16;
                  break;
                }

                return _context2.abrupt("return", true);

              case 16:
                _context2.next = 11;
                break;

              case 18:
                _context2.next = 23;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2["catch"](9);

                _iterator.e(_context2.t0);

              case 23:
                _context2.prev = 23;

                _iterator.f();

                return _context2.finish(23);

              case 26:
                return _context2.abrupt("return", false);

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[9, 20, 23, 26]]);
      }));

      function anyCloser(_x2) {
        return _anyCloser.apply(this, arguments);
      }

      return anyCloser;
    }()
  }]);

  return PeerDistanceList;
}();

module.exports = PeerDistanceList;